<div class="location-card-container" [class.can-edit]="canEdit()">
  <div
    class="location-card"
    [class.is-selected]="isSelected()"
    [class.can-edit]="canEdit()"
    [class.is-editing]="isEditing"
    (click)="onClick.emit()">
    @if (isSelected() && canEdit()) {
      <div class="drag-handle" cdkDragHandle [style.pointer-events.none]="confirmRemove">
        <i class="icon icon-drag_handle"></i>
      </div>

      @if (!location().isWorld) {
        <div class="actions-container">
          <i [title]="'MAP-DISPLAY.BUTTONS.EDIT-LOCATION-NAME' | translate" class="icon icon-edit" (click)="isEditing = true"></i>
          <i
            [title]="'MAP-DISPLAY.BUTTONS.SET-LOCATION-FROM-MAP' | translate"
            class="icon icon-small_tack"
            (click)="onSetLocationFromMap.emit()"></i>
          <i [title]="'MAP-DISPLAY.BUTTONS.DELETE-LOCATION' | translate" class="icon icon-delete_trash" (click)="confirmRemove = true"></i>
        </div>

        @if (confirmRemove) {
          <div class="remove-location">
            <button type="button" class="button is-secondary" (click)="confirmRemove = false">
              <i class="icon icon-close-X"></i>
            </button>
            <button type="button" class="button is-danger" (click)="onRemove.emit()">
              <i class="icon icon-delete_trash"></i>
            </button>
          </div>
        }

        @if (isEditing) {
          <div class="edit-location-name">
            <input #locationName type="text" class="input is-small" [value]="location().name" />
            <button
              type="button"
              class="button is-primary is-small"
              (click)="onNameChange.emit(locationName.value); isEditing = !locationName.value">
              <i class="icon icon-check_clear"></i>
            </button>
            <button type="button" class="button is-secondary is-small" (click)="isEditing = false">
              <i class="icon icon-close-X"></i>
            </button>
          </div>
        }
      }
    }

    <div class="row" [title]="location().name">
      @if (settings().showFlag) {
        @if (location().isWorld) {
          <img class="world-icon" src="/assets/images/world.svg" />
        } @else if (location().alpha2CountryCode) {
          <i [class]="'flag-icon fi fi-' + location().alpha2CountryCode.toLowerCase()"></i>
        }
      }

      @if (location().isWorld) {
        <span class="name">{{ 'MAP-DISPLAY.LOCATIONS.WORLD' | translate }}</span>
      } @else {
        <span class="name">{{ location().name }}</span>
      }
    </div>

    @if (showLocationInfo()) {
      <div class="row location-info">
        @if (settings().showTime && locationDate()) {
          <div class="info-text">
            <span>{{ locationDate().time$ | async }}</span>
            @if (locationDate().meridiem$ | async; as meridiem) {
              <span class="alt-text">&nbsp;{{ meridiem }}</span>
            }
          </div>
        }

        @if (weatherInfo()) {
          @if (settings().showTemperature && temperature() !== null) {
            <div class="info-text">
              <span>{{ temperature() }}&#176;</span>
              <span class="alt-text">&nbsp;{{ temperatureUnit() }}</span>
            </div>
          }

          @if (settings().showWeather && weatherIcon()) {
            <img class="weather-icon" [src]="weatherIcon()" />
          }
        }
      </div>
    }

    @if (location().isWorld && settings().showTime) {
      <div class="row">
        <span class="info-text">{{ locationDate().date$ | async }}</span>
      </div>
    }
  </div>
</div>
